/**
 * T5 Live Orders Popup - JavaScript
 */

// Array of sample orders for T5
const orders = [
    { name: "Patrick", location: "NJ", product: "T(5) 1 Bottle", time: "12 minutes ago" },
    { name: "Vladimir", location: "Israel", product: "T(5) 1 Bottle", time: "15 minutes ago" },
    { name: "Brandon", location: "CO", product: "T(5) 1 Bottle", time: "18 minutes ago" },
    { name: "Rustin", location: "LA", product: "T(5) 1 Bottle", time: "21 minutes ago" },
    { name: "Daniel", location: "AL", product: "T(5) 1 Bottle", time: "24 minutes ago" },
    { name: "John", location: "FL", product: "T(5) 3 Bottles", time: "28 minutes ago" },
    { name: "Robert", location: "KY", product: "T(5) 1 Bottle", time: "31 minutes ago" },
    { name: "Malcolm", location: "WA", product: "T(5) 1 Bottle", time: "34 minutes ago" },
    { name: "Jesse", location: "IN", product: "T(5) 1 Bottle", time: "37 minutes ago" },
    { name: "Adhiraj", location: "NH", product: "T(5) 1 Bottle", time: "40 minutes ago" },
    { name: "David", location: "AP", product: "T(5) 1 Bottle", time: "11 minutes ago" },
    { name: "Michael", location: "CA", product: "T(5) 1 Bottle", time: "14 minutes ago" },
    { name: "Murray", location: "WA", product: "T(5) 1 Bottle", time: "17 minutes ago" },
    { name: "Andrew", location: "TN", product: "T(5) 1 Bottle", time: "20 minutes ago" },
    { name: "Juan", location: "IL", product: "T(5) 1 Bottle", time: "23 minutes ago" },
    { name: "Nick", location: "VA", product: "T(5) Bundle", time: "10 minutes ago" },
    { name: "Murray", location: "WA", product: "T(5) Bundle", time: "13 minutes ago" },
    { name: "Marlon", location: "CA", product: "T(5) Bundle", time: "16 minutes ago" },
    { name: "Bryan", location: "MA", product: "T(5) Bundle", time: "19 minutes ago" },
    { name: "Nicholas", location: "NJ", product: "T(5) Bundle", time: "22 minutes ago" },
    { name: "Kort", location: "CA", product: "T(5) Bundle", time: "25 minutes ago" },
    { name: "Alex", location: "FL", product: "T(5) Bundle", time: "28 minutes ago" },
    { name: "Mike", location: "ON", product: "T(5) Bundle", time: "31 minutes ago" },
    { name: "Ryan", location: "SC", product: "T(5) Bundle", time: "34 minutes ago" },
    { name: "Peter", location: "CA", product: "T(5) Bundle", time: "37 minutes ago" },
    { name: "Saroop", location: "BC", product: "T(5) Bundle", time: "12 minutes ago" },
    { name: "Michael", location: "TX", product: "T(5) Bundle", time: "15 minutes ago" },
    { name: "Adan", location: "NC", product: "T(5) Bundle", time: "18 minutes ago" },
    { name: "James", location: "MI", product: "T(5) Bundle", time: "21 minutes ago" },
    { name: "Thomas", location: "FL", product: "T(5) Bundle", time: "24 minutes ago" }
];

// Display popup function
function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    
    popup.innerHTML = `
        <div class="popup-content">
            <div class="popup-image">
                <img style="border-radius: 5px;" src="${randomOrder.product.includes('Bundle') 
                    ? 'https://cdn.shopify.com/s/files/1/2443/2395/files/Power_Dad_Stack_2_Zoom.png?v=1733357721' 
                    : 'https://cdn.shopify.com/s/files/1/2443/2395/files/T5_T-Boost_Zoom.png?v=1733357818'}" alt="Product Image">
                <span class="glow-dot"></span>
            </div>
            <div class="popup-text">
                <div class="popup-line">
                    <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
                </div>
                <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
                <div class="popup-line order-time">${randomOrder.time}</div>
                <div class="verified-buyer-badge">Verified Buyer</div>
            </div>
        </div>
    `;
    
    popup.style.display = 'block';

    setTimeout(() => {
        popup.classList.add('popup-hide');
    }, 6000);

    setTimeout(() => {
        popup.style.display = 'none';
        popup.classList.remove('popup-hide');
        setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
}

// Random time intervals between popups
function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
}

// Start the popup display
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
});
